
const RecipeTroubleshooting = () => {
  return (
    <div className="bg-secondary/50 p-6 rounded-lg my-8 border border-secondary">
      <h3 className="text-xl font-medium mb-2">Troubleshooting Tips</h3>
      <ul className="list-disc pl-5 text-muted-foreground space-y-2">
        <li><span className="font-medium">Cookies too brittle:</span> You may have overbaked them or spread the batter too thin. Try reducing baking time by 30 seconds.</li>
        <li><span className="font-medium">Cookies too soft:</span> They may be underbaked or the batter might be too thick. Try baking longer or thinning the batter with a teaspoon of water.</li>
        <li><span className="font-medium">Cookies browning too quickly:</span> Your oven may be too hot. Reduce temperature by 25°F and watch closely.</li>
        <li><span className="font-medium">Trouble with shaping:</span> Work faster or prepare fewer cookies per batch. You only have a few seconds before they harden!</li>
      </ul>
    </div>
  );
};

export default RecipeTroubleshooting;
